"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpendingSummaryV2 = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _index = require("../../../index");
var getSpendingSummaryV2 = exports.getSpendingSummaryV2 = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (token, scheme, tetheredUserGuid) {
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    try {
      var response = yield (0, _index.executeGraphQLQuery)((0, _api.getAccountBalanceSummaryV2)(), {
        scheme,
        tetheredUserGuid
      }, result => result, token, revalidateCache, returnErrors);
      return response;
    } catch (error) {
      return null;
    }
  });
  return function getSpendingSummaryV2(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();